<template>
<div class="pro-detail-view" :class="hasMdcode ? 'hasMdcode' : ''">
  <com-header :compID="productDetail.CompID" activeKey="prod" v-if="productDetail.CompID && productDetail.CompID != 0" @returnCompInfo="setCompInfo"></com-header>
  <div class="product-con layout-router">
    <div class="product-params" v-show="!isAffix">
      <catalog-tree
        title="产品目录"
        categoryType="ProdDir"
        :defaultNode="[{ DirName: '产品目录' ,DirID: 0,TreeID: 'list_0'}]"
        :compID="productDetail.CompID"
        v-if="productDetail.CompID != 0 && productDetail.SID !== undefined"
        viewHeight="calc(100vh - 72px)"
        affixTop="40px"
        :lazy="false"
        :defaultExpandedKeys="[`list_${productDetail.SID}`]"
        :currentKey="`list_${productDetail.SID}`"
        @dirChanged="dirChanged"
      ></catalog-tree>
    </div>
    <div class="product-detail">
      <div class="top-con">
        <!-- 3D -->
          <div class="box-3d">
            <div class="preview-top">
              <div @click="changePreviewType('3D')"  :class="previewType == '3D' ? 'preview-tab active' : 'preview-tab'">3D预览</div>
              <div @click="changePreviewType('2D')" :class="previewType == '2D' ? 'preview-tab active' : 'preview-tab'">平面图</div>
            </div>
            <div v-show="previewType == '3D'" ref="scrollElement" class="iframe-box" :class="isFullScreen?'full-screen':''">
              <div v-if="showEmptyText" class="empty-3d">
                <div style="display:flex;align-items:center;justify-content:center;margin:20px auto;color:#124B92;">
                  <img src="/resource/images/icon1.png" alt="" width="24px" style="cursor: pointer;">
                  <span  style="margin-left:8px;font-weight:700;">因为型号未确定，所以不能进行3D预览。</span>
                </div>
                  <div style="display:flex;justify-content:center;">
                    <img src="/resource/images/icon2.png" alt="" width="100px">
                  </div>
                  <div style="line-height:24px;color:#999;margin-top:20px;">要使用“3D预览”功能 需要完成“产品选型”,请过滤规格和尺寸确定型号后，进行3D预览的操作。</div>
              </div>
            </div>
           <!-- 产品banner图 -->
            <div class="special-3d">
              <pro-banner
              :templateKey="'top'"
              :lectoParams="lectoParams"
              :productDetail="productDetail"
              @insertProdFavorite="insertProdFavorite"
              :existProd="existProd"
              :dataSource="document_list.logos"
              v-if="document_list.logos.length > 0"
              :noSwiper="previewType === '3D'"
            ></pro-banner>
            </div>
          </div>
        <!-- 产品banner图 -->
        <!-- <pro-banner
          :templateKey="'top'"
          :lectoParams="lectoParams"
          :productDetail="productDetail"
          @insertProdFavorite="insertProdFavorite"
          :existProd="existProd"
          :dataSource="document_list.logos"
          v-if="document_list.logos.length > 0"
        ></pro-banner> -->
        <!-- 参数选型 -->
        <lecto-params
          :productDetail="productDetail"
          :lectoParams="lectoParams"
          :lectoProId="lectoProId"
          :checkParams="checkParams"
          :isSkuFavorite="isSkuFavorite"
          :templateKey="'top'"
          @_checkParamsChange="_checkParamsChange"
          @_clearCheckParams="_clearCheckParams"
          @noticeParentMessage="noticeParentMessage"
        ></lecto-params>
        <product-qrcode
          :mdCode="mdCode"
          :compLogo="compInfo.compLogo"
          :productDetail="productDetail"
          :lectoParams="lectoParams"
          v-if="hasMdcode"
        ></product-qrcode>
      </div>
      <div class="btm-detail" :class="isAffix ? 'detai-lecto-fixed' : ''">
        <detailTab
          :document_list="document_list"
          :productIntro="productIntro"
          :isAffix="isAffix"
          :compID="productDetail.CompID"
          :islock="islock"
          @isLockChange="isLockChange"
        ></detailTab>

        <div class="detai-lecto" :style="{ height: contentHeight }">
          <!-- 产品banner图 -->
          <pro-banner :templateKey="'detail'" :lectoParams="lectoParams" :productDetail="productDetail"  @insertProdFavorite="insertProdFavorite" :existProd="existProd" :dataSource="document_list.logos" v-if="document_list.logos.length > 0"></pro-banner>
          <!-- 参数选型 -->
          <lecto-params
            :productDetail="productDetail"
            :lectoParams="lectoParams"
            :lectoProId="lectoProId"
            :checkParams="checkParams"
            :isSkuFavorite="isSkuFavorite"
            :templateKey="'detail'"
            @_checkParamsChange="_checkParamsChange"
            @_clearCheckParams="_clearCheckParams"
          ></lecto-params>
        </div>
      </div>
    </div>
  </div>

  <export-lecto :productDetail="productDetail"></export-lecto>

  <member-order ref="memberOrderRef"></member-order>

  <platform-customer ref="platformCustomerRef"></platform-customer>

  <whole-confirm ref="wholeConfirmRef"></whole-confirm>
</div>
</template>

<script>
import dayjs from 'dayjs';
import {CheckLibs, UserService as ModuleUserService, Category} from '@digital-supply-chain/module'
import { ProductService, UserService, FavoriteService, Message, CompService, OpenService, TodaySearchService } from '@/service';

import ComHeader from '@/views/company/header/index.vue';
import CatalogTree from '@/components/tree-list/catalog-tree.vue';
import ProBanner from './banner.vue';
import LectoParams from './lectoParams.vue';
import ExportLecto from './exportLecto.vue';
import DetailTab from './detailTab/index.vue';
import MemberOrder from './components/MemberOrder.vue';
import ProductQrcode from './components/product-qrcode.vue';
import PlatformCustomer from './components/PlatformCustomer.vue';
import { WinForm, DomainService, ProductSelectionNotice } from '@/libs';
import {  decryptPhone } from "@/utils/utils";


import { defaultLectoParams, defaultLectoParamsByKey, getLectoFavoriteParams, getStandardData } from './lectoParamsDown';

import fangdaImg from '@/assets/images/fangda.png';
import suoxiaoImg from '@/assets/images/suoxiao.png';

const isLockKey = 'product_detail_lock';

export default {
  data() {
    return {
      standardData: {}, // 标准件产品的数据
      lectoProId: 0, // 用于选型的产品id
      mdCode: '',

      productDetail: {}, // 产品详情
      productIntro: null, // 产品富文本详情
      lectoParams: { LectotypeParams: [] }, // 选型参数
      checkParams: {}, // 选中的选型参数
      document_list: {
        samples: [],
        sizes: [],
        logos: [],
      }, // 产品文件
      productDocs: [], // 外购件相关资料

      // 当前选中的选型参数是否已加入我的常用零配件
      isSkuFavorite: false,

      existProd: false,
      isAffix: false,
      islock: WinForm.storge.get(isLockKey) ? Number(WinForm.storge.get(isLockKey)) : 0,

      // 当前产品企业信息
      compInfo: {},

      //tudo
      fangdaImg,
      suoxiaoImg,
      previewType: '2D',
      isFullScreen: false, // 默认全屏
      showEmptyText: false,
    }
  },
  components: { ComHeader, CatalogTree, ProBanner, LectoParams, DetailTab, ExportLecto, MemberOrder, PlatformCustomer, ProductQrcode },
  provide() {
    return {
      standardData: () => this.standardData,
      productDocs: this.productDocs,
      productDetail: this.productDetail,
      downLoadCheck: this.downLoadCheck,
      // tudo
      handleClickPreview: this.handleClickPreview,
      createIframe: this.createIframe,
    }
  },
  mounted() {
    this.lectoProId = this.$route.params.id;

    this.getInfo();
    this.existProdFavorite();

    if (!CheckLibs.isClient()) {
      this.islock = 1;
    }

    document.querySelector('.main-container').addEventListener('scroll', (e) => {
      if (this.islock && !this.isAffix) return;
      const topHeight = document.querySelector('.top-con').clientHeight;
      const scrollNum = this.productDetail.CompID == 0 ? (topHeight - 65) : (115 + topHeight);
      if (document.querySelector('.main-container').scrollTop >= scrollNum) {
        this.isAffix = true;
        document.querySelector('.main-container').scrollTop = document.querySelector('.pro-detail-view').clientHeight;
      } else{
        this.isAffix = false;
      }
    })
  },
  computed: {
    contentHeight() {
      return this.productDetail.CompID == 0 ? 'calc(100vh - 18px)' : 'calc(100vh - 60px)';
    },
    hasMdcode() {
      return this.mdCode && this.compInfo.compId && (CheckLibs.isGreatCraftsman() || CheckLibs.isGreatCraftsmanEnt())
    }
  },
  methods: {
    // 3D尺寸自适容器
    init3d() {
       const iframeDom = document.querySelector('.iframe-box iframe');
       if(!iframeDom) { return; }
        // 向 iframe 发送消息
        iframeDom.contentWindow.postMessage({
          type: 'messageInit',
          data: 'init'
        }, '*');
    },
     // 预览模式
    changePreviewType(type) {
      this.previewType = type;
      if(type === '3D') {
        try{
        // 易分析埋点
        const CompName = this.compInfo.CompName || '平台方'
        const {ProdName,ProdID} =this.productDetail;
          _yfx_trackdata.push(['event','3D预览切换点击',ProdName,ProdID,CompName]);
        }catch(er) {}
        setTimeout(()=> { this.init3d(); },200)
      }
     
    },
    // 预览下载处理，给预览按钮使用
    handleClickPreview() {
      this.previewType = '3D';
      setTimeout(()=> { this.init3d(); },200)
    },
    // 模型预览iframe 模式
    createIframe(url) {
      if(!url) return;
      const iframeBox = document.querySelector('.iframe-box');
      iframeBox.innerHTML = `<img class="fangda-btn" src=${fangdaImg} /><img src=${suoxiaoImg} class="suoxiao-btn hide" />`;

      // iframeBox.innerHTML = ``;

      // 添加原生事件监听
      const fangdaBtn = iframeBox.querySelector('.fangda-btn');
      const suoxiaoBtn = iframeBox.querySelector('.suoxiao-btn');
      fangdaBtn.addEventListener('click', this.handlefangda.bind(this,fangdaBtn, suoxiaoBtn));
      suoxiaoBtn.addEventListener('click', this.handlesuoxiao.bind(this,fangdaBtn, suoxiaoBtn));
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && this.isFullScreen) {
          this.handlesuoxiao(fangdaBtn, suoxiaoBtn);
        }
      });

      const iframeEle = document.createElement('iframe');
      iframeEle.width = '100%';
      iframeEle.height ='100%';
      iframeEle.setAttribute("frameborder", 0)
      iframeEle.onload = () => {
      }
      iframeEle.src = url;
      iframeBox.appendChild(iframeEle);

    },
    handlefangda(fangdaBtn, suoxiaoBtn) {
      fangdaBtn.classList.add('hide');
      suoxiaoBtn.classList.remove('hide');
      this.isFullScreen = true;
      setTimeout(()=> { this.init3d(); },200)
      
    },
     handlesuoxiao(fangdaBtn, suoxiaoBtn) {
      fangdaBtn.classList.remove('hide');
      suoxiaoBtn.classList.add('hide');  
      this.isFullScreen = false;
       setTimeout(()=> { this.init3d(); },200)
    },

    // 全局的下载前拦截
    downLoadCheck(confirm, close, data) {
      if (!this.productDetail.CompID || this.productDetail.CompID == 0) {
        confirm && confirm(data);
        return;
      };
      const vipLevel = this.compInfo.vipLevel || 0;
      const vipText = CompService.blueVip(vipLevel);
      if (vipText) {
        confirm && confirm(data);
        return;
      }
      UserService.isDownload(this.productDetail.ProdID).then(res => {
        if (res.code == 0) {
          confirm && confirm(data);
        } else {
          this.$refs.wholeConfirmRef.open({
              width: '460px',
              content: `<div style="padding: 4px 2px 0;margin-bottom: 10px;">
                <div style="display: flex; align-items: center; gap: 10px; margin-bottom: 16px;">
                  <div style="width: 32px; height: 32px; border-radius: 50%; background: linear-gradient(135deg, #FFC08A, #F56C6C); display: flex; align-items: center; justify-content: center; flex-shrink: 0; box-shadow: 0 4px 10px rgba(245, 108, 108, .24);">
                    <span style="color: #fff; font-size: 20px; font-weight: 700; line-height: 1;">!</span>
                  </div>
                  <div style="font-size: 18px; font-weight: 700; color: #303133; letter-spacing: .5px;">友情提示</div>
                </div>
                <div style="color: #606266; font-size: 14px; line-height: 1.95; margin-bottom: 18px;">
                  该零部件所属企业目前非平台正式会员，模型数据正确性无法保障，因此<span style="color: #F56C6C; font-weight: 700; padding: 0 2px;">暂时不能下载</span>。为了确保数据准确，请您致电该零部件企业，请他们尽快联系平台运营方，以确保产品数据、尺寸参数、联系信息准确有效。
                </div>
                <div style="background: linear-gradient(135deg, #FFF8EC, #FFF1D9); border: 1px solid #FFE1A8; border-radius: 12px; padding: 16px 18px; display: flex; gap: 12px; align-items: flex-start;">
                  <div style="width: 34px; height: 20px; border-radius: 5px; background: linear-gradient(135deg, #F5C871, #E6A23C); color: #fff; font-size: 12px; font-weight: 700; letter-spacing: .5px; display: flex; align-items: center; justify-content: center; flex-shrink: 0; margin-top: 2px;">VIP</div>
                  <div style="color: #8B6D3B; font-size: 13px; line-height: 1.9;">
                    同时，我们开通了<span style="color: #E6A23C; font-weight: 700;">超级会员</span>权限，成为超级会员后，平台全部企业产品模型可<span style="color: #F56C6C; font-weight: 700;">自由下载</span>，请自行校对相关模型数据，并获得参与平台建设的权利。
                  </div>
                </div>
              </div>`,
              confirmText: '联系企业',
              cancelText: '了解一下超级会员',
              showCancel: true,
              showConfirm: true,
              cancelType: 'warning',
              confirm: () => {
                // confirm && confirm(data);
                this.callCompany();
              },
              cancel: () => {
                close && close(data)
                this.payVip();
              },
          })
        }
      });
    },

    async payVip() {
      const res = await TodaySearchService.getPayType();
      const type = (res.data || {}).type || 1;
      setTimeout(() => {
        if (type == 1) this.$refs.memberOrderRef.open();
        if (type == 2) this.$refs.platformCustomerRef.open();
      }, 300);
    },

    async callCompany() {
      const res = await CompService.GetPublicUsers(this.compInfo.CompId);
      res.forEach(item => {
          item.Phone = decryptPhone(item.PhoneEncrypt);
      });
      const customerList = res || [];
      const {CompName,Phone} = this.compInfo;
      let userStr = '';
      customerList.forEach(item => {
          userStr = userStr + (item.CSName || item.NickName) + '：' + item.Phone + '<br/>'
      })
      this.$refs.wholeConfirmRef.open({
          width: '480px',
          content: `<div style="padding: 4px 2px 0;">
            <div style="display: flex; align-items: center; gap: 10px; margin-bottom: 16px;">
              <div style="width: 32px; height: 32px; border-radius: 50%; background: linear-gradient(135deg, #66B1FF, #409EFF); display: flex; align-items: center; justify-content: center; flex-shrink: 0; box-shadow: 0 4px 10px rgba(64, 158, 255, .24);">
                <svg width="16" height="16" viewBox="0 0 24 24"><path d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z" fill="#fff"/></svg>
              </div>
              <div style="font-size: 18px; font-weight: 700; color: #303133; letter-spacing: .5px;">请联系该供应商</div>
            </div>
            <div style="color: #606266; font-size: 14px; line-height: 1.95; margin-bottom: 18px;">
              要求此供应商企业尽快联系平台修正产品信息和完善联系方式，成为平台规范供应商。
            </div>
            <div style="background: #F4F9FF; border: 1px solid #DCEDFF; border-radius: 12px; padding: 16px 18px; margin-bottom: 16px;">
              <div style="display: flex; align-items: center; margin-bottom: 14px;">
                <span style="color: #909399; font-size: 13px; width: 72px; flex-shrink: 0;">企业名称</span>
                <span style="font-weight: 700; color: #303133; font-size: 16px;">${CompName}</span>
              </div>
              <div style="display: flex; align-items: center;${userStr ? ' margin-bottom: 14px;' : ''}">
                <span style="color: #909399; font-size: 13px; width: 72px; flex-shrink: 0;">企业电话</span>
                <span style="color: #409EFF; font-weight: 700; font-size: 20px; letter-spacing: .5px;">${Phone}</span>
              </div>
              ${userStr ? `<div style="display: flex; align-items: flex-start; padding-top: 14px; border-top: 1px dashed #DCEDFF;">
                <span style="color: #909399; font-size: 13px; width: 72px; flex-shrink: 0; line-height: 1.9;">联系人</span>
                <div style="color: #606266; font-size: 14px; line-height: 1.9;">${userStr}</div>
              </div>` : ''}
            </div>
            <div style="background: #F4F9FF; border: 1px solid #DCEDFF; border-radius: 10px; padding: 14px 16px;">
              <div style="color: #606266; font-size: 13px; line-height: 1.7;">
                大国工匠（大工程师）平台客服电话：<span style="color: #409EFF; font-weight: 700; font-size: 16px;">19564151511</span>
              </div>
              <div style="margin-top: 8px; color: red; font-size: 12px; line-height: 1.7;">注意：该电话不是供应商企业，请先按照上述企业联系方式找到您需要的产品所在供应商企业。</div>
            </div>
          </div>`,
          showCancel: false,
          showConfirm: false,
      })
    },

    // 选中的参数变化
    async _checkParamsChange (key, ItemID, value, Remark) {
      const checkParams = this.checkParams;
      !checkParams[ItemID] && (checkParams[ItemID] = {});
      checkParams[ItemID].ItemID = ItemID;
      checkParams[ItemID].ItemName = key;
      checkParams[ItemID].ItemValue = value;
       checkParams[ItemID].Remark = Remark;
      !checkParams[ItemID].ItemValue && (delete checkParams[ItemID])
      this.checkParams = checkParams;
      this.filterLectotypeParams();
    },
    // 清空选中的参数
    _clearCheckParams() {
      this.checkParams = {};
      this.noticeParentMessage(ProductSelectionNotice.CheckParamsClear);
      this.filterLectotypeParams();
    },

    setCompInfo(data) {
      this.compInfo = data;
      const status = (this.compInfo.info && this.compInfo.info.status === 0) ? 0 : 1;
      if (status == 0) {
          window.location.replace(`${location.origin}/exception/productrepeal/${this.$route.params.id}`)
          return false;
      }
    },

    // ======== 数据获取部分 START ========
    // 获取产品详情
    async getInfo() {
      const res = await ProductService.getInfo(this.$route.params.id);
      if (res) {
        UserService.viewLogs('Prod', this.$route.params.id)
        this.productDetail = res;
        document.title = res.ProdName;

        this.getDirIDByProdInfo();
      } else {
        Message.error('产品已下架');
      }
    },
    // 获取目录id,富文本详情Intro
    async getDirIDByProdInfo() {
      let res = {};
      try {
        res = await ProductService.getProdIntro(this.$route.params.id)
      } catch (error) {}
      if (res.code === 0) {
        if (res.data) {
           // 进页面是否显示3D模型逻辑处理
          const curUrl = res.data?.htInfo?.url ||'';
           this.showEmptyText = !curUrl;
          //  this.createIframe('http://localhost:3000/index.html')
           if(curUrl) {
              this.createIframe(curUrl)
           }
          // 暂时隐藏掉
          // this.previewType = curUrl ?'3D': '2D';

          this.productDetail.SID = res.data.SID || res.data.sid || '0';
          this.productIntro = res.data.intro || '';

          this.mdCode = res.data.MdCode || '';

          // 从ProdJsonParams中获取需要关联的模型产品id
          this.standardData = getStandardData(res.data.prodJsonParams);
          this.standardData.standard_id && (this.lectoProId = Number(this.standardData.standard_id));
          this.standardData.standard_id && (this.getLectoYbFiles());
        }

        this.getLec();
        this.getFiles();
      }
    },

    // 获取选型样本
    async getLectoYbFiles() {
      const res = await ProductService.getFiles(this.lectoProId, 0);
      if (res) {
        res.forEach(element => {
          switch (element.FileType) {
            case 1:
              this.document_list.samples.push(element);
              break;
            case 2:
              this.document_list.sizes.push(element);
              break;
          }
        });
      }
    },

    // 获取产品文件
    async getFiles() {
      const res = await ProductService.getFiles(this.$route.params.id, 0);
      if (res) {
        if (this.productDetail.ProdLogo) {
          this.document_list.logos.push({
            FileServerPath: this.productDetail.ProdLogo,
            ID: new Date().getTime(),
          })
        }
        res.forEach(element => {
          switch (element.FileType) {
            case 1:
              this.document_list.samples.push(element);
              break;
            case 2:
              this.document_list.sizes.push(element);
              break;
            case 3:
            case 4:
              this.document_list.logos.push(element);
              break;
            case 8:
            case 9:
              this.productDocs.push(element);
              break;
            default:
              break;
          }
        });
      }
    },
    // 获取选型参数
    async getLec() {
      const res = await ProductService.getLec(this.lectoProId);
      res && (this.lectoParams = res);

      this.checkParams = await defaultLectoParamsByKey(this.checkParams, this.lectoParams);

      // 默认参数填充
      this.checkParams = defaultLectoParams(this.checkParams, this.lectoParams);
      this.filterLectotypeParams();
    },
    // 选型参数过滤
    async filterLectotypeParams() {
      const res = await ProductService.filterLectotypeParams(this.lectoProId, Object.values(this.checkParams));
      if (!res) return false;
      res.LectotypeParams = res.LectotypeParams || [];
      const LectoParams = res || [];
      let checkParams = this.checkParams;
      LectoParams.LectotypeParams.forEach((item, index) => {

        if (checkParams[item.ID]) {
          let value = checkParams[item.ID].ItemValue.toString() || '';
          if (item.Values && !item.Values.includes(value) && item.ParamType !== 1) {
            delete checkParams[item.ID];
            LectoParams.LectotypeParams[index].Value = '';
          }
        } else {
          delete checkParams[item.ID];
        }
      });

      // 进行value、values参数重置，解决部分参数存在换行、空格等非法字符
      LectoParams.LectotypeParams = LectoParams.LectotypeParams.map(item => {
        let Value = item.Value ? item.Value.replace(/[\r\n]/g,"") : '';

        return {
          ...item,
          Value,
          Values: item.Values ? item.Values.map(m => m.replace(/[\r\n]/g,"")) : [],
        }
      })
      LectoParams.SkuName && (LectoParams.SkuName = LectoParams.SkuName.replace(/[\r\n]/g,""))
      LectoParams.StepFileName && (LectoParams.StepFileName = LectoParams.StepFileName.replace(/[\r\n]/g,""))

      this.lectoParams = LectoParams;
      this.checkParams = checkParams;
      this.noticeParentMessage(LectoParams.IsSelected ? ProductSelectionNotice.LectotypeDimension : ProductSelectionNotice.CheckParamsChange);
      this.existSkuFavorite();
    },

    // ====== 产品收藏 ======
    async existProdFavorite() {
      if (!ModuleUserService.token()) {
        return false;
      }
      const res = await ProductService.existProdFavorite(this.$route.params.id);
      res && (this.existProd = res);
    },
    async insertProdFavorite(currentNode) {
      if (this.existProd) return;
      await ProductService.insertProdFavorite(this.$route.params.id, currentNode.DirID);
      this.existProdFavorite();
    },

    // 选型参数是否收藏
    async existSkuFavorite() {
      if (!CheckLibs.isClient()) {
        return false;
      }
      if (!this.lectoParams.SkuName) {
        return false;
      }
      const favoriteData = getLectoFavoriteParams(this.productDetail, this.lectoParams, this.checkParams);
      const res = await FavoriteService.getModelParamsExists(favoriteData.md5);
      if (res.code === 0) {
        this.isSkuFavorite = res.data || false;
      }
    },

    affixChange(bol) {
      this.isAffix = bol;
    },
    // 左右布局锁改变
    isLockChange(value) {
      if (!CheckLibs.isClient()) {
        return false;
      }
      this.islock = value;
      WinForm.storge.set(isLockKey, value);
    },

    // 左侧目录树变化
    dirChanged(data) {
      if (data.DirID == Number(this.productDetail.SID)) return;
      WinForm.storge.localAdd('dir_id', data.DirID);
      if (OpenService.getRouterTarget() == '_self') {
        window.location.href = `/product/list/${this.productDetail.CompID}`;
      } else {
        window.open(`/product/list/${this.productDetail.CompID}`);
      }
    },

    /**
     * 通知父级
    */
    noticeParentMessage(key) {
      const {SkuID , SkuName} = this.lectoParams;
      const {ProdID, ProdName} = this.productDetail;
      if (!window.parent) return;
      window.parent.postMessage({
        key,
        data: {
          SkuID,
          SkuName,
          ProdID,
          ProdName,
          CompId: this.compInfo.CompId,
          CompName: this.compInfo.CompName,
          SelectParams: Object.values(this.checkParams),
        }
      }, "*")
    }
  }
}
</script>

<style lang="less" scoped>
 .empty-3d {
    color: rgb(9, 137, 197);
    padding: 16px 20px;
    background: #F1F1F1;
    margin-top: 20px;
    width: 90%;
    margin-left: 5%;
    // text-align: center;
  }
.box-3d {
  float:left;
  width:281px;
  // position: relative;
}
.preview-top{
  display: flex;
  margin-right: 16px;
  border: 1px solid #ddd;
  border-bottom: none;
  background: #F1F1F1;
}
.preview-tab {
  cursor: pointer;
  padding: 0 12px;
  line-height: 30px;
  width: 100px;
  text-align: center;
  position: relative;
  // clear: both;
}
.special-3d ::v-deep .banner-swiper1 {
  border-top:0;
}
.preview-tab:hover {
  color: #0989C5;
}
.preview-tab.active {
  background: #fff;
  // border-top: 1px solid #C3A271;
}
.preview-tab.active::before{
  content: '';
  display: block;
  width: 100px;
  height: 3px;
  background: #C3A271;
  position: absolute;
  left: 0;
  top: -1px;
  z-index: 1;
}
.iframe-box {
  border: 1px solid #ddd;
  border-top: 0;
  width: 265px;
  margin-right: 16px;
  height: 337px;
  flex: 1;
  transition: all 0.3s ease-in-out;
  position: relative;
}
 .iframe-box ::v-deep .mask {
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: 5;
}
.iframe-box.full-screen {
  height: 100vh;
  width: 100vw;
  z-index: 999;
  top: 0;
  left: 0;
  position: fixed;
  cursor: pointer;
}
.iframe-box /deep/ .fangda-btn {
  position: absolute;
  z-index: 10;
  right: 10px;
  bottom: 10px;
  width: 30px;
  opacity: 0.5;
  cursor: pointer;
}
.iframe-box /deep/ .suoxiao-btn{
  position: absolute;
  z-index: 10;
  right: 10px;
  bottom: 10px;
  width: 30px;
  opacity: 0.5;
  cursor: pointer;

}
.iframe-box /deep/ .suoxiao-btn:hover, .iframe-box /deep/ .fangda-btn:hover {
  opacity: 1;
}
.iframe-box /deep/ .hide {
  display: none;
}



.pro-detail-view.hasMdcode{
  min-width: 1340px;
}
.product-con{
  display: flex;
  position: relative;
  transition: all 0.4s;
}
.product-params{
  margin-right: 10px;
}
.top-con{
  width: 100%;
  padding: 16px;
  background: #ffffff;
  box-shadow: 0px 0px 14px 0px #EAEEFF;
  border: 1px solid #D6D6D6;
  margin-bottom: 8px;
}
.top-con::after{
  content: '';
  display: block;
  clear: both;
  width: 100%;
  height: 0;
}
.btm-detail{
  display: flex;
}
.detai-lecto{
  width: 0;
  transition: all 0.4s;
  overflow-x: hidden;
  background: #ffffff;
}
.detai-lecto-fixed{
  /deep/ .detail-tab{
    flex: 1;
    width: calc(100% - 20px - 592px - 8px);
  }
  .detai-lecto{
    width: 592px;
    padding: 16px;
    box-shadow: 0px 0px 14px 0px #EAEEFF;
    border: 1px solid #D6D6D6;
    margin-left: 8px;
  }
}
.product-detail{
  flex: 1;
}
</style>
